module.exports = __webpack_public_path__ + "assets/img/word-study-addnew.bd9ee9ef.png";